import { RouterOutlined } from "@material-ui/icons";
import { TenantOwnEldsList } from "./TenantOwnEldsList";

export default {
  icon: RouterOutlined,
  list: TenantOwnEldsList,
};
